import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const baseVariantShared: CustomTheme.CSSProperties = {
  alignItems: 'center',
  textAlign: 'center',
};

const featureGridHeading = {
  default: { ...baseVariantShared },
  leftAlign: { ...baseVariantShared },
  darkBackground: { ...baseVariantShared },
};

const co: CustomTheme.VariantCSSKeys<HeadingVariantsType> = {
  default: {
    ...baseVariantShared,
  },
  leftAlign: {
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  darkBackground: {
    ...baseVariantShared,
    '*, .featureGridSectionTitle, p': {
      color: 'coolGrey.0',
    },
  },
};

const heading: Product.VariantKeyModes<HeadingVariantsType> = {
  products: {
    chart: featureGridHeading,
    chartblog: featureGridHeading,
    co,
    edu: featureGridHeading,
    scale: featureGridHeading,
    spark: featureGridHeading,
  },
};

export type HeadingVariantsType = 'default' | 'leftAlign' | 'darkBackground';
export const headingVariants = Object.keys(featureGridHeading) as HeadingVariantsType[];

export default heading;
